import * as actions from './history.actions';
import { State } from './interfaces/state.interface';
import { ActionType as AT } from './enums/action-type.enum';
import { StateType } from './enums/state-type.enum';

type InferValueTypes<T> = T extends { [key: string]: infer U } ? U : never;
type Action = ReturnType<InferValueTypes<typeof actions>>;

class HistoryState {
	currentState: State = {
		type: StateType.INITIAL
	};
	stack: State[] = [];
}

export const historyReducer = (state:HistoryState= new HistoryState(), action:Action):HistoryState => {
	switch (action.type) {
		case AT.ADD_STATE: {
			return {...state, currentState: action.payload, stack: [...state.stack, state.currentState]};
		}
		
		case AT.ROLL_BACK_STATE: {
			const lastElement = state.stack[state.stack.length - 1];
			return { ...state, currentState: lastElement, stack: state.stack.filter(item => item != lastElement)};
		}
		
		case AT.SET_STATE: {
			return {currentState: action.payload, stack: []};
		}

		default: return state;
	}
}
